export const constantValues = {
  defaultFields: ["isDeleted", "isActive", "createdAt", "updatedAt", "addedBy", "updatedBy"],
};

export const STOCK_ITEM_OPTIONS = [
  { value: "1 Ltr", label: "1 Ltr" },
  { value: "4 Ltr", label: "4 Ltr" },
  { value: "5 Ltr", label: "5 Ltr" },
  { value: "CUBE 6 NORMAL", label: "CUBE 6 NORMAL" },
  { value: "CUBE 6 SR", label: "CUBE 6 SR" },
  { value: "CUBE 6 LR", label: "CUBE 6 LR" },
  { value: "CUBE 13 NORMAL", label: "CUBE 13 NORMAL" },
  { value: "CUBE 13 SR", label: "CUBE 13 SR" },
  { value: "CUBE 13 LR", label: "CUBE 13 LR" },
  { value: "CUBE 25", label: "CUBE 25" },
  { value: "CUBE 56", label: "CUBE 56" },
  { value: "CUBE XD", label: "CUBE XD" },
  { value: "CELLOTAPE AIRFEILD", label: "CELLOTAPE AIRFEILD" },
  { value: "MOTHERBAG BIG", label: "MOTHERBAG BIG" },
  { value: "MOTHERBAG MEDIUM", label: "MOTHERBAG MEDIUM" },
  { value: "MOTHERBAG SMALL", label: "MOTHERBAG SMALL" },
  { value: "3 PLY CORRUGATED BOX - AF 1", label: "3 PLY CORRUGATED BOX - AF 1" },
  { value: "3 PLY CORRUGATED BOX - AF 2", label: "3 PLY CORRUGATED BOX - AF 2" },
  { value: "3 PLY CORRUGATED BOX - AF 4", label: "3 PLY CORRUGATED BOX - AF 4" },
  { value: "LOGI SEAL", label: "LOGI SEAL" },
  { value: "OTHER", label: "OTHER" },
];

export const CATEGORY_OPTIONS = [
  { value: "Packaging", label: "Packaging" },
  { value: "Stationery", label: "Stationery" },
  { value: "Equipment", label: "Equipment" },
  { value: "Other", label: "Other" },
];

export const GST_OPTIONS = [
  { value: "07AALCA0600L1ZW", label: "07AALCA0600L1ZW - Delhi", username: "Airfield_Delhi" },
  { value: "24AALCA0600L1Z0", label: "24AALCA0600L1Z0 - Gujarat", username: "Airfield_Guj" },
  { value: "27AALCA0600L1ZU", label: "27AALCA0600L1ZU - Maharashtra", username: "AIRFIELD.MAH" },
  { value: "09AALCA0600L1ZS", label: "09AALCA0600L1ZS - UP", username: "Airfield_UP" },
  { value: "29AALCA0600L1ZQ", label: "29AALCA0600L1ZQ - Karnataka", username: "Airfield_kar" },
];

export const roles = {
  SUPER_ADMIN: "Admin",
  BRANCH_ADMIN: "Branch",
  SUBBRANCH_ADMIN: "SubBranch",
  AGENT: "DELIVERY",
  ACCOUNTANT: "Accountant",
  HR_CS: "HR & CUSTOMER SERVICE",
  CS_DELIVERY: "CUSTOMER SERVICE & DELIVERY",
  CUSTOMER_SERVICE: "CUSTOMER SERVICE",
  MANAGER: "Manager",

  MIS_CREDIT_CASH: "MIS - CASH & CREDIT",
  PURCHASE: "PURCHASE",
  SALES: "SALES",

  CA_READ_ONLY: "CA - READ ONLY",
};
export const ETA_TIME = {
  "18 24 PARGANAS_AHMEDABAD": 48,
  ABOHAR_AHMEDABAD: 48,
  "ABU ROAD_AHMEDABAD": 24,
  AGRA_AHMEDABAD: 24,
  AHMEDABAD_NOIDA: 24,
  AHMEDABAD_MUMBAI: 24,
  AHMEDABAD_AHMEDABAD: 24,
  "AHMEDABAD_NEW DELHI": 24,
  AHMEDABAD_NAVIMUMBAI: 24,
  AHMEDABAD_HIMMATNAGAR: 24,
  AHMEDABAD_BANGALORE: 24,
  AHMEDABAD_KOLKATA: 24,
  AHMEDABAD_BILASPUR: 48,
  AHMEDABAD_VARANASI: 48,
  AHMEDABAD_CHAKAN: 24,
  AHMEDABAD_PUNE: 24,
  AHMEDABAD_BARODA: 24,
  AHMEDABAD_GURGAON: 24,
  AHMEDABAD_HYDERABAD: 24,
  AHMEDNAGAR_NAVIMUMBAI: 24,
  AHMEDNAGAR_AHMEDABAD: 24,
  AJMER_AHMEDABAD: 24,
  AJMER_PUNE: 48,
  AKOLA_AHMEDABAD: 24,
  ALIGARH_AHMEDABAD: 48,
  ALLAHABAD_AHMEDABAD: 24,
  ALLAHABAD_PUNE: 48,
  ALLAHABAD_ALLAHABAD: 24,
  "ALLAHABAD_NEW DELHI": 24,
  AMALNER_AHMEDABAD: 48,
  AMBALA_AHMEDABAD: 48,
  AMBERNATH_NAVIMUMBAI: 24,
  AMBERNATH_VAPI: 48,
  AMBERNATH_AHMEDABAD: 48,
  AMRAVATI_AHMEDABAD: 24,
  AMRITSAR_AHMEDABAD: 48,
  ANAND_KOLKATA: 48,
  ANDERGAM_AHMEDABAD: 48,
  ANKLESHWAR_NAVIMUMBAI: 24,
  ASANSOL_AHMEDABAD: 48,
  AURANGABAD_AHMEDABAD: 24,
  AURANGABAD_MUMBAI: 24,
  BADDI_NAVIMUMBAI: 48,
  BAGALKOT_AHMEDABAD: 48,
  BAHADURGARH_AHMEDABAD: 48,
  "BAHADURGARH_NEW DELHI": 24,
  BANDA_AHMEDABAD: 48,
  BANGALORE_AHMEDABAD: 24,
  BANGALORE_GANDHINAGAR: 24,
  BANGALORE_MUMBAI: 24,
  BANGALORE_NAVIMUMBAI: 24,
  BANGALORE_HYDERABAD: 24,
  BANGALORE_KANNUR: 48,
  BARAMATI_AHMEDABAD: 48,
  BARAUT_AHMEDABAD: 48,
  BAREILY_AHMEDABAD: 48,
  "BARMER _AHMEDABAD": 24,
  BARODA_AHMEDABAD: 24,
  "BARODA_NEW DELHI": 24,
  BARODA_MUMBAI: 24,
  BARODA_PUNE: 24,
  BARODA_NAVIMUMBAI: 24,
  BARODA_NOIDA: 24,
  "BARPETA ROAD_AHMEDABAD": 48,
  "BARWALA_NEW DELHI": 48,
  BEAWAR_AHMEDABAD: 48,
  BEED_AHMEDABAD: 48,
  BEHRAMPUR_AHMEDABAD: 48,
  BELGAUM_AHMEDABAD: 24,
  "BHADOHI_NEW DELHI": 24,
  BHAGALPUR_AHMEDABAD: 48,
  BHARATPUR_AHMEDABAD: 48,
  BHARATPUR_MUMBAI: 48,
  BHARUCH_AHMEDABAD: 24,
  BHATINDA_AHMEDABAD: 48,
  BHAVNAGAR_AHMEDABAD: 24,
  BHILAI_AHMEDABAD: 48,
  BHOPAL_AHMEDABAD: 48,
  BHUBANESHWAR_AHMEDABAD: 48,
  BHUBANESHWAR_MUMBAI: 48,
  BHUSAWAL_AHMEDABAD: 48,
  BIDADI_AHMEDABAD: 48,
  BIKANER_AHMEDABAD: 24,
  BILASPUR_AHMEDABAD: 48,
  "BILASPUR-HP_AHMEDABAD": 72,
  BULANDSHAHAR_AHMEDABAD: 48,
  BUTIBORI_AHMEDABAD: 48,
  CHAKAN_AHMEDABAD: 24,
  CHANDIGARH_AHMEDABAD: 24,
  "CHANDIGARH_NEW DELHI": 24,
  CHANDIGARH_NAVIMUMBAI: 48,
  CHANDRAPUR_AHMEDABAD: 48,
  CHENNAI_AHMEDABAD: 24,
  CHENNAI_MUMBAI: 24,
  CHENNAI_PUNE: 48,
  CHENNAI_GANDHINAGAR: 48,
  CHIDAMBARAM_AHMEDABAD: 48,
  CHIPLUN_AHMEDABAD: 48,
  COIMBATORE_AHMEDABAD: 48,
  COIMBATORE_PUNE: 48,
  CUTTACK_AHMEDABAD: 48,
  DAHOD_AHMEDABAD: 24,
  DEHRADUN_AHMEDABAD: 48,
  DEHRADUN_NAVIMUMBAI: 48,
  DEWAS_AHMEDABAD: 48,
  DHARAMSHALA_AHMEDABAD: 48,
  DHARASHIV_AHMEDABAD: 48,
  DHARWAD_AHMEDABAD: 48,
  DHULE_AHMEDABAD: 24,
  DIBRUGARH_AHMEDABAD: 72,
  DOMBIVILI_AHMEDABAD: 24,
  DURGAPUR_AHMEDABAD: 48,
  ERNAKULAM_AHMEDABAD: 48,
  ERODE_AHMEDABAD: 48,
  ETAWAH_AHMEDABAD: 48,
  FAIZABAD_AHMEDABAD: 48,
  FARIDABAD_AHMEDABAD: 24,
  FARIDKOT_AHMEDABAD: 48,
  FIROZABAD_AHMEDABAD: 48,
  FIROZEPUR_AHMEDABAD: 48,
  GANDHINAGAR_AHMEDABAD: 24,
  GANDHINAGAR_GHAZIABAD: 24,
  GANDHINAGAR_MUMBAI: 24,
  GANGAVATHI_AHMEDABAD: 48,
  GAYA_AHMEDABAD: 48,
  GHAZIABAD_AHMEDABAD: 24,
  "GHAZIABAD_NEW DELHI": 24,
  GHAZIABAD_MUMBAI: 24,
  GOA_AHMEDABAD: 24,
  GORAKHPUR_AHMEDABAD: 24,
  GULBARGA_AHMEDABAD: 48,
  GUNJDUNDWARA_AHMEDABAD: 48,
  GUNTUR_PUNE: 48,
  GUNTUR_AHMEDABAD: 48,
  GURGAON_AHMEDABAD: 24,
  "GURGAON_NEW DELHI": 24,
  GUWAHATI_AHMEDABAD: 48,
  GUWAHATI_PUNE: 48,
  GUWAHATI_MUMBAI: 48,
  GWALIOR_AHMEDABAD: 48,
  HALOL_NAVIMUMBAI: 24,
  HARIDWAR_BANGALORE: 48,
  HASSAN_AHMEDABAD: 48,
  HAZIRA_BARODA: 24,
  HIMMATNAGAR_AHMEDABAD: 24,
  HISSAR_AHMEDABAD: 48,
  HOOGHLY_AHMEDABAD: 48,
  HOSHIARPUR_AHMEDABAD: 48,
  HOSKOTE_NAVIMUMBAI: 48,
  HOSUR_AHMEDABAD: 48,
  "HOWRAH MAIN_AHMEDABAD": 48,
  HUBLI_AHMEDABAD: 48,
  HYDERABAD_AHMEDABAD: 24,
  HYDERABAD_NAVIMUMBAI: 24,
  HYDERABAD_PUNE: 24,
  HYDERABAD_BARODA: 48,
  HYDERABAD_MUMBAI: 24,
  HYDERPORA_AHMEDABAD: 48,
  INDORE_AHMEDABAD: 24,
  INDORE_NAVIMUMBAI: 24,
  "INDORE_NEW DELHI": 48,
  JABALPUR_AHMEDABAD: 24,
  JAIPUR_AHMEDABAD: 24,
  JAIPUR_GANDHINAGAR: 24,
  JAIPUR_PUNE: 48,
  JAISALMER_AHMEDABAD: 24,
  JALANDHAR_AHMEDABAD: 48,
  JALGAON_AHMEDABAD: 24,
  JALNA_AHMEDABAD: 24,
  JAMMU_AHMEDABAD: 48,
  JAMSHEDPUR_AHMEDABAD: 48,
  JAUNPUR_AHMEDABAD: 48,
  JHANSI_AHMEDABAD: 48,
  JIGANI_NAVIMUMBAI: 24,
  JIND_AHMEDABAD: 48,
  JODHPUR_AHMEDABAD: 24,
  JORHAT_AHMEDABAD: 72,
  JUNAGADH_AHMEDABAD: 24,
  KAITHAL_AHMEDABAD: 48,
  KALOL_AHMEDABAD: 24,
  KANGRA_AHMEDABAD: 48,
  KANGRA_MUMBAI: 48,
  KANNUR_AHMEDABAD: 48,
  KANPUR_AHMEDABAD: 24,
  "KANPUR_NEW DELHI": 24,
  KANPUR_MUMBAI: 48,
  KARNAL_AHMEDABAD: 48,
  KASARAGOD_AHMEDABAD: 48,
  KASHIPUR_AHMEDABAD: 48,
  "KHAMANO KALAN_AHMEDABAD": 48,
  KHED_AHMEDABAD: 24,
  KHURJA_MUMBAI: 48,
  KISHANGARH_AHMEDABAD: 24,
  KOCHI_AHMEDABAD: 48,
  KOLHAPUR_AHMEDABAD: 24,
  KOLHAPUR_PUNE: 24,
  KOLKATA_AHMEDABAD: 24,
  KOLKATA_MUMBAI: 24,
  KOLKATA_PUNE: 48,
  KOLKATA_BANGALORE: 24,
  KOTA_AHMEDABAD: 24,
  KOZHIKODE_AHMEDABAD: 48,
  KUDAL_AHMEDABAD: 48,
  KURNOOL_AHMEDABAD: 48,
  KURUKSHETRA_AHMEDABAD: 48,
  LATUR_AHMEDABAD: 24,
  LONAVALA_BHUBANESHWAR: 72,
  LUCKNOW_AHMEDABAD: 24,
  LUCKNOW_PUNE: 48,
  LUCKNOW_MUMBAI: 48,
  LUDHIANA_AHMEDABAD: 48,
  MACHEDA_AHMEDABAD: 48,
  MADURAI_AHMEDABAD: 48,
  MANDLA_AHMEDABAD: 48,
  MANDYA_AHMEDABAD: 48,
  MANESAR_NAVIMUMBAI: 48,
  MANGALORE_AHMEDABAD: 48,
  MANGALORE_PUNE: 48,
  MANGALORE_BARODA: 48,
  MANIPAL_AHMEDABAD: 48,
  "MARAIMALAI NAGAR_PUNE": 48,
  "MARAIMALAI NAGAR_AHMEDABAD": 48,
  MATHURA_AHMEDABAD: 48,
  MEERUT_AHMEDABAD: 48,
  MEHSANA_AHMEDABAD: 24,
  MHOW_NAVIMUMBAI: 48,
  MODINAGAR_AHMEDABAD: 48,
  MOHALI_AHMEDABAD: 48,
  MORADABAD_AHMEDABAD: 48,
  MUMBAI_AHMEDABAD: 24,
  MUMBAI_BHAGALPUR: 72,
  MUMBAI_NAVIMUMBAI: 24,
  MUMBAI_GURGAON: 24,
  MUMBAI_PUNE: 24,
  MUMBAI_MUMBAI: 24,
  MUMBAI_BARODA: 24,
  MUMBAI_VIJAYAWADA: 48,
  MUMBAI_BANGALORE: 24,
  MYSORE_AHMEDABAD: 48,
  MYSORE_PUNE: 48,
  NABHA_AHMEDABAD: 48,
  NADIA_AHMEDABAD: 48,
  NADIAD_AHMEDABAD: 24,
  NAGPUR_AHMEDABAD: 24,
  NAGPUR_MUMBAI: 24,
  NAGPUR_PUNE: 24,
  NANDED_AHMEDABAD: 24,
  NASIK_AHMEDABAD: 24,
  NASIK_PUNE: 24,
  NASIK_BANGALORE: 48,
  "NASIK ROAD_AHMEDABAD": 24,
  NAVIMUMBAI_AHMEDABAD: 24,
  NAVIMUMBAI_NAVIMUMBAI: 24,
  NAVIMUMBAI_PUNE: 24,
  NAWANSHAHR_AHMEDABAD: 48,
  NELLORE_MUMBAI: 48,
  NELLORE_AHMEDABAD: 48,
  "NEW DELHI_AHMEDABAD": 24,
  "NEW DELHI_SURAT": 24,
  "NEW DELHI_MUMBAI": 24,
  "NEW DELHI_NEW DELHI": 24,
  "NEW DELHI_SONEPAT": 24,
  "NEW DELHI_PUNE": 24,
  "NEW DELHI_BARODA": 24,
  NIZAMABAD_AHMEDABAD: 48,
  NOIDA_AHMEDABAD: 24,
  OUTERSRINAGAR_AHMEDABAD: 72,
  PALAMPUR_AHMEDABAD: 48,
  PALANPUR_AHMEDABAD: 24,
  PANCHKULA_KOLKATA: 48,
  PANIPAT_AHMEDABAD: 48,
  PANVEL_AHMEDABAD: 24,
  PARBHANI_AHMEDABAD: 48,
  PARBHANI_MUMBAI: 48,
  PATAN_AHMEDABAD: 24,
  PATHANKOT_AHMEDABAD: 48,
  PATIALA_AHMEDABAD: 48,
  PATNA_AHMEDABAD: 48,
  PATNA_GANDHINAGAR: 48,
  PATNA_PUNE: 48,
  PINJORE_AHMEDABAD: 48,
  PITHAMPUR_NAVIMUMBAI: 24,
  PONDICHERRY_AHMEDABAD: 72,
  PUNE_MUMBAI: 24,
  PUNE_AHMEDABAD: 24,
  PUNE_NAGPUR: 24,
  PUNE_PUNE: 24,
  PUNE_BANGALORE: 24,
  "PUNE_NEW DELHI": 24,
  RAIPUR_AHMEDABAD: 24,
  RAJKOT_AHMEDABAD: 24,
  "RAJKOT_NEW DELHI": 48,
  RAJNANDGAON_AHMEDABAD: 48,
  RAJPURA_AHMEDABAD: 48,
  RAMPUR_AHMEDABAD: 48,
  RANCHI_AHMEDABAD: 48,
  RANIPET_AHMEDABAD: 48,
  RATLAM_AHMEDABAD: 48,
  RAVET_AHMEDABAD: 24,
  REWA_AHMEDABAD: 48,
  RISHIKESH_AHMEDABAD: 48,
  ROHTAK_AHMEDABAD: 48,
  ROORKEE_AHMEDABAD: 48,
  ROPAR_AHMEDABAD: 48,
  ROURKELA_AHMEDABAD: 48,
  RUDRAPUR_AHMEDABAD: 24,
  SAHRANPUR_AHMEDABAD: 48,
  SALEM_AHMEDABAD: 48,
  SALUGARA_AHMEDABAD: 72,
  SAMBALPUR_AHMEDABAD: 48,
  SANAND_NAVIMUMBAI: 24,
  SANGLI_AHMEDABAD: 24,
  SANGRUR_AHMEDABAD: 48,
  SATARA_AHMEDABAD: 48,
  SHILLONG_AHMEDABAD: 72,
  "SHILLONG_NEW DELHI": 48,
  SHIMLA_AHMEDABAD: 48,
  SHIMOGA_AHMEDABAD: 48,
  SHIRUR_AHMEDABAD: 48,
  SHOLINGANALLUR_MUMBAI: 48,
  SIDDIPET_AHMEDABAD: 48,
  SIRSA_AHMEDABAD: 48,
  SITARGANJ_AHMEDABAD: 48,
  SIWAN_AHMEDABAD: 48,
  SOLAPUR_AHMEDABAD: 24,
  SOLAPUR_MUMBAI: 24,
  SONEPAT_AHMEDABAD: 48,
  SRIGANGANAGAR_AHMEDABAD: 48,
  SRIKAKULAM_AHMEDABAD: 72,
  SRINAGAR_AHMEDABAD: 72,
  SURAT_AHMEDABAD: 24,
  SURAT_MUMBAI: 24,
  "SURAT_NEW DELHI": 24,
  SURAT_PUNE: 24,
  SURAT_GANDHINAGAR: 24,
  TELLICHERRY_AHMEDABAD: 48,
  THANE_NAVIMUMBAI: 24,
  THIRUVANANTHAPURAM_AHMEDABAD: 48,
  THRISSUR_AHMEDABAD: 48,
  TIRUCHIRAPALLI_AHMEDABAD: 48,
  TIRUNELVELI_AHMEDABAD: 48,
  TIRUPATI_AHMEDABAD: 48,
  UDAIPUR_AHMEDABAD: 24,
  ULHASNAGAR_AHMEDABAD: 24,
  UNJHA_AHMEDABAD: 24,
  VAPI_AHMEDABAD: 24,
  VAPI_KANPUR: 72,
  VAPI_NAVIMUMBAI: 24,
  VARANASI_AHMEDABAD: 24,
  VARANASI_JAIPUR: 48,
  VARANASI_PUNE: 48,
  VARANASI_MUMBAI: 48,
  "VARANASI_NEW DELHI": 24,
  VARANASI_BANGALORE: 48,
  VELLORE_AHMEDABAD: 48,
  VIJAYAWADA_AHMEDABAD: 48,
  VISHAKAPATNAM_AHMEDABAD: 48,
  VISHAKAPATNAM_MUMBAI: 48,
  VISHAKAPATNAM_BANGALORE: 24,
  VIZIANAGARAM_AHMEDABAD: 72,
  VRINDABAN_AHMEDABAD: 48,
  WASHIM_AHMEDABAD: 48,
  YADGIR_AHMEDABAD: 48,
  YAMUNANAGAR_AHMEDABAD: 48,
  YAVATMAL_AHMEDABAD: 48,
  YERPEDU_AHMEDABAD: 48,
  ZIRAKPUR_AHMEDABAD: 48,
};
